import { Component, OnInit } from '@angular/core';
import { Jezik } from './jezik';
import { ModalContainerService, BaseUpdateComponent, BaseDataService, BaseModalUpdateComponent, ModalService } from 'yt-ng-framework';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
// import { NotificationsService } from 'angular2-notifications';
import { ActivatedRoute } from '@angular/router';
import { Validators } from '@angular/forms';

@Component({
  selector: 'yt-jezik-modal-update',
  templateUrl: './jezik-modal-update.component.html'
})
export class JezikModalUpdateComponent extends BaseModalUpdateComponent<Jezik> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<Jezik>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) {
    super(modalContainerService, activeModal,modalService);
  }

  ngOnInit() {
    super.ngOnInit();
  }

}
